import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";
import { ofetch } from "ofetch";

const getSelection = async <FormattedSelection>({
  token,
  setToken,
  api,
  formatter,
  signal,
}: {
  token?: string | null;
  setToken: (token: string) => void;
  api: string;
  formatter: (selection: BaseSelectionResponse) => FormattedSelection;
  signal?: AbortSignal;
}) => {
  const headers = new Headers([["Content-Type", "application/json"]]);
  if (token) {
    headers.append("API-Token", token);
  }

  const selection = await ofetch(`${api}/selection`, {
    headers,
    method: "GET",
    cache: "no-cache",
    signal,
  });

  setToken(selection.token);

  const data = selection;

  return formatter(data);
};

export default getSelection;
